<template>
  <div class="testimonials">
    <h1 class="text-center pt-5">{{ $t("landing.testimonials.title") }}</h1>

    <swiper
      :modules="modules"
      class="swiper-container container"
      :slides-per-view="slidesPerView"
      :space-between="40"
      :centeredSlides="isMobile()"
      navigation
      :pagination="{ clickable: true }"
      :scrollbar="{ draggable: true }"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        class="comment"
        v-for="(comment, i) in testimonials"
        v-bind:key="i"
      >
        <div>
          <img v-if="comment.image" :src="comment.image" alt="" />
          <span class="name">{{ comment.name }}</span>
          <span class="position">{{
            $t("landing.testimonials.member_since", { date: comment.position })
          }}</span>
          <!--          <br class="clear">-->
          <p>
            {{
              $t("landing.testimonials.message", {
                message_es: comment.message_es,
                message_en: comment.message_en,
              })
            }}
          </p>
        </div>
      </swiper-slide>
    </swiper>
    <br class="clear" />
  </div>
</template>
<style lang="scss">
@import "src/assets/scss/colors";
.webp {
  .testimonials {
    .comment {
      background: url("@/assets/img/testimonial-bg-closed.webp") no-repeat
        bottom center;
      background-size: 100% 100%;
    }
  }
}
.testimonials {
  background-color: $dark-blue;
  position: relative;
  padding: 4em 0;

  .container {
    padding: 1em 0;
  }

  * {
    transition: background 0.3s, left 0.3s, top 0.3s, display 0.3s;
  }
  .comment {
    background: url("@/assets/img/testimonial-bg-closed.png") no-repeat bottom
      center;
    background-size: contain;
    padding: 2.5em;

    img {
      position: relative;
      top: 5em;
      padding-top: 1em;
      width: 25%;
      margin-right: 1.5em;
    }
    .clear {
      clear: both;
    }
    .name {
      position: relative;
      left: 0; //6em;
      padding-top: 1.5em;
      display: block;
    }
    .position {
      display: block;
      color: $red-light;
      text-transform: uppercase;
      font-size: 0.7em;
      font-weight: 400;
      margin-top: 0.3em;
      position: relative;
      left: 0; //8.5em;
    }
    p {
      display: -webkit-box;
      margin: 1em 0 0;
      font-size: 0.8em;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media (max-width: 767px) {
    .swiper-wrapper {
      padding-bottom: 3em;
    }
    .comment {
      > div {
        padding: 0.4em;
      }
    }
  }
  /* iPhone pro max */
  //@media only screen and (width: 430px) and (height: 932px) and (-webkit-device-pixel-ratio: 3) {
  //  .comment {
  //    padding: 2.5em;
  //  }
  //}
  --swiper-pagination-bullet-inactive-color: #ffffff;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-color: $red;
  .swiper-wrapper {
    padding-bottom: 3em;
  }
  .swiper-pagination-bullet-active {
    background-color: $red;
    opacity: 1;
  }
  
  @media (min-width: 1920px) {
    font-size: 0.8vw;
  }
}
</style>
<script>
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default {
  name: "Testimonials",
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    slidesPerView() {
      return this.isMobile() ? 1.1 : 3;
    },
  },
  data() {
    return {
      testimonials: [
        {
          image: null,
          name: "Melissa Morillo",
          position: "2018",
          message_en:
            "“I was looking for movies in Spanish and I found a large variety of good films in Spanish on FlixLatino.”",
          message_es:
            "“Estaba buscando películas en español y encontré una gran variedad de buenas películas en español en FlixLatino.”",
        },
        {
          image: null,
          name: "Santiago Valentín",
          position: "2022",
          message_en:
            "“My mother loves the Turkish series in Spanish and FlixLatino has the best ones right now.”",
          message_es:
            "“A mi madre le encantan las series turcas en español y FlixLatino tiene las mejores en este momento.”",
        },
        {
          image: null,
          name: "Diana Valenzuela",
          position: "2023",
          message_en:
            "“Great selection of series in Spanish at an accessible price point. The best streaming at the best price.”",
          message_es:
            "“Gran selección de series en español a un precio accesible. El mejor streaming al mejor precio.”",
        },
      ],
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y],
    };
  },
};
</script>
